import { UrlMatchResult, UrlSegment } from '@angular/router';
import { standardToLangMap, supportedLangs } from '../helpers/i18n/lang-mappers';

export function langMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  const supported = supportedLangs;

  if (segments.length > 0 && supported.includes(standardToLangMap[segments[0].path])) {
    return {
      consumed: [segments[0]],
      posParams: {
        lang: segments[0],
      },
    };
  }

  return null;
}
